import {requestTimeout, handleResponse} from '../utils'
// import { Cookies } from 'react-cookie'

const apiUrl = process.env.REACT_APP_API_URL
// const accessToken = process.env.REACT_APP_ACCESS_TOKEN
const apiMaxTime = process.env.REACT_APP_API_EXEC_TIME

// const cookie = new Cookies();

export const courseApi = {
    _all,
    _get,
    _featured,
    _buy_course,
    _my_courses,
    _get_details,
    
};


async function _all() {    

    const token = localStorage.getItem(process.env.REACT_APP_AUTH_COOKIE)    
    const requestOptions = {
        method: 'GET',
        credentials: "include",
        headers: {
            'Authorization': 'Bearer '+ token,
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        }
    };
    return requestTimeout(apiMaxTime,fetch(apiUrl + 'courses', requestOptions))
                .then(handleResponse)
                .then((response) => {                    
                    return response
                });
    
}


async function _get(slug) {

   
    const token = localStorage.getItem(process.env.REACT_APP_AUTH_COOKIE)    
    const requestOptions = {
        method: 'GET',
        credentials: "include",
        headers: {
            'Authorization': 'Bearer '+ token,
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        }
    };
    return requestTimeout(apiMaxTime,fetch(apiUrl + 'courses/'+slug, requestOptions))                    
                .then(handleResponse)
                .then((response) => {    
                    return response
                })                
        
}

async function _featured() {     
    const token = localStorage.getItem(process.env.REACT_APP_AUTH_COOKIE)    

    const requestOptions = {
        method: 'GET',
        credentials: "include",
        headers: {
            'Authorization': 'Bearer '+ token,
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        }
    };
    return requestTimeout(apiMaxTime,fetch(apiUrl + 'courses/featured', requestOptions))
                .then(handleResponse)
                .then((response) => {                    
                    return response
                });
    
}

async function _buy_course(form_data) {     
    
    const token = localStorage.getItem(process.env.REACT_APP_AUTH_COOKIE)    
    const requestOptions = {
        method: 'POST',
        credentials: "include",
        headers: {
            'Authorization': 'Bearer '+ token,
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
        body: JSON.stringify(form_data)
    };
    return requestTimeout(apiMaxTime,fetch(apiUrl + 'courses/purchase', requestOptions))
                .then(handleResponse)
                .then((response) => {                    
                    return response
                });
    
}

async function _my_courses() {     
    
    const token = localStorage.getItem(process.env.REACT_APP_AUTH_COOKIE)    
    const requestOptions = {
        method: 'GET',
        credentials: "include",
        headers: {
            'Authorization': 'Bearer '+ token,
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        }
    };
    return requestTimeout(apiMaxTime,fetch(apiUrl + 'account/courses', requestOptions))
                .then(handleResponse)
                .then((response) => {                    
                    return response
                });
    
}

async function _get_details(slug) {     
    
    const token = localStorage.getItem(process.env.REACT_APP_AUTH_COOKIE)    
    const requestOptions = {
        method: 'GET',
        credentials: "include",
        headers: {
            'Authorization': 'Bearer '+ token,
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        }
    };
    return requestTimeout(apiMaxTime,fetch(apiUrl + 'account/courses/'+slug, requestOptions))
                .then(handleResponse)
                .then((response) => {                    
                    return response
                });
    
}

